import styled from 'theme';

export const ApplicationFormLabel = styled.label`
  display: inline-block;
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 2;
  color: ${p => p.theme.variables.customColors.textColor};
`;
